import { Component, Input, OnChanges, SimpleChange, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-strengh-password-checker',
  templateUrl: './strengh-password-checker.component.html'
})
export class StrenghPasswordCheckerComponent implements OnChanges {
  @Input() public passwordToVerify: string | undefined = undefined;
  @Output() passwordStrength = new EventEmitter<boolean>();
  msg = '';
  passwordColor = '';
  width = 0;
  isPassedMinlenght: boolean = false;
  isPassedUppercase: boolean = false;
  isPassedLowercase: boolean = false;
  isPassedNumbericDigits: boolean = false;
  isPassedNotContainName: boolean = false;
  ngOnChanges(changes: { [propName: string]: SimpleChange }): void {
    if (changes['passwordToVerify']) {
      const password = changes['passwordToVerify'].currentValue;
      const minLength = 8;
      const hasUpperCase = /[A-Z]/.test(password);
      const hasLowerCase = /[a-z]/.test(password);
      const hasNumber = /\d/.test(password);
      const hasSpecialCharacter = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(password);
      if (password) {
        password.length >= minLength
          ? (this.isPassedMinlenght = true)
          : (this.isPassedMinlenght = false);
        hasUpperCase ? (this.isPassedUppercase = true) : (this.isPassedUppercase = false);

        hasLowerCase ? (this.isPassedLowercase = true) : (this.isPassedLowercase = false);

        hasNumber ? (this.isPassedNumbericDigits = true) : (this.isPassedNumbericDigits = false);

        if (password.length < minLength || !hasUpperCase || !hasLowerCase || !hasNumber) {
          this.msg = 'lbl.poor';
          this.passwordColor = '#F00125';
        } else if (!hasSpecialCharacter) {
          this.msg = 'lbl.fair';
          this.passwordColor = '#FCBE05';
        }

        if (
          password.length >= minLength &&
          hasUpperCase &&
          hasLowerCase &&
          hasSpecialCharacter &&
          hasNumber
        ) {
          this.msg = 'lbl.good';
          this.passwordColor = '#57B72D';
        }
      } else {
        this.resetCondition();
      }
      this.width = this.calcPasswordStrengthWidth(password);
    }
  }

  calcPasswordStrengthWidth(password: any): number {
    if (!password || password.length === 0) {
      return 0;
    }
    let strength = 0;
    const lengthRegex = new RegExp('.{8,}');
    const uppercaseRegex = new RegExp('.*[A-Z].*');
    const lowercaseRegex = new RegExp('.*[a-z].*');
    const digitRegex = new RegExp('.*[0-9].*');
    if (password.length >= 8) {
      strength += 25;
    }

    if (uppercaseRegex.test(password)) {
      strength += 25;
    }

    if (lowercaseRegex.test(password)) {
      strength += 25;
    }

    if (digitRegex.test(password)) {
      strength += 25;
    }
    return strength;
  }

  resetCondition() {
    this.isPassedMinlenght = false;
    this.isPassedUppercase = false;
    this.isPassedLowercase = false;
    this.isPassedNumbericDigits = false;
    this.isPassedNotContainName = false;
    this.msg = 'lbl.poor';
    this.passwordColor = '#F00125';
  }
}
